import * as React from 'react';

function Check(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="check-icon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 6c0-3.305 2.672-6 6-6 3.305 0 6 2.695 6 6 0 3.328-2.695 6-6 6-3.328 0-6-2.672-6-6zm8.695-1.031a.637.637 0 000-.914.637.637 0 00-.914 0L5.25 6.585l-1.055-1.03a.637.637 0 00-.914 0 .637.637 0 000 .914l1.5 1.5a.637.637 0 00.914 0l3-3z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Check;
